import { styled } from '@tools/wr-catalog-base'

export const ModalDescription = styled.p`
  padding: 20px;
  text-align: center;
`
